import React from 'react';

import { resetImage } from '@/common/reset-image';

import doLog from '../../common/log';

import './index.less';

const VERIFIED_PRO_ICON =
  'https://img.alicdn.com/imgextra/i1/O1CN016rthU61YZ1a37KVsB_!!6000000003072-2-tps-246-45.png';
const VERIFIED_ICON =
  'https://img.alicdn.com/imgextra/i2/O1CN01OhiUgP22fNY7nmUGL_!!6000000007147-2-tps-153-39.png';
const VERIFIED_PRO_BG =
  'https://img.alicdn.com/imgextra/i1/O1CN01oGQTeC1tBIzu2F2yt_!!6000000005863-2-tps-2250-144.png';
const VERIFIED_BG =
  'https://img.alicdn.com/imgextra/i4/O1CN01vkS5p71sQabHhuw1U_!!6000000005761-2-tps-2250-144.png';
const GOLDEN_BG =
  'https://img.alicdn.com/imgextra/i1/O1CN01NZ3RqO1x9i58QRzlj_!!6000000006401-2-tps-2250-144.png';
export default function CompanyInfo(props: SellerType.Root & { abtest: DetailTypes.Abtest }) {
  const {
    // 付费用户即会员gs
    accountIsPaidMember,
    // 是gps用户即金品认证用户
    accountIsGoldPlusSupplier,
    //是领袖商家即verified pro
    accountIsLeaderSupplier,
    companyName,
    homeUrl,
    companyRegisterCountry = '',
    companyJoinYears,
    authCards,
    overseaBrand,
    companyLogoFileUrlSmall,
    sellerSelfOperated,
    selfOperatedInfo,
    abtest,
  } = props;

  // PPE商家不展示
  if (selfOperatedInfo) {
    return null;
  }

  //公司供应商类型，如Custom manufacturer
  const companyIdentityName = authCards && authCards.value?.identityInfo?.identityName;

  //普通商家
  const isNormal = accountIsPaidMember && !accountIsGoldPlusSupplier && !accountIsLeaderSupplier;
  //Verified商家
  const isVerified = accountIsPaidMember && accountIsGoldPlusSupplier && !accountIsLeaderSupplier;
  //VerifiedPro商家
  const isVerifiedPro = accountIsPaidMember && accountIsGoldPlusSupplier && accountIsLeaderSupplier;

  const showCompanyCard = abtest?.pc_detail_company_card === 'show_company_card';

  const renderCompanyName = () => {
    // 预建联店铺域名
    try {
      addDNSPrefetchTags(homeUrl);
    } catch (e) {
      console.error('Failed to add DNS prefetch tags:', e);
    }

    return (
      <span className="company-name detail-separator">
        <a
          href={homeUrl}
          target="_blank"
          title={companyName}
          onClick={() => {
            doLog('/sc.details.top_company');
          }}
        >
          {companyName}
        </a>
      </span>
    );
  };

  const renderStyle = () => {
    if (isVerified) {
      return {
        backgroundImage: `url(${resetImage(VERIFIED_BG)})`,
      };
    }
    if (isVerifiedPro) {
      return {
        backgroundImage: `url(${resetImage(VERIFIED_PRO_BG)})`,
      };
    }
  };

  return (
    <div className={`product-company`} style={renderStyle()}>
      {/* 公司头像*/}
      {companyLogoFileUrlSmall && (
        <img
          className="company-logo"
          src={companyLogoFileUrlSmall}
          alt="company-logo"
          loading={'lazy'}
        />
      )}
      {/* 公司名称链接  */}
      <div className="product-company-info">
        {renderCompanyName()}
        {/* verify标，认证标 */}
        {(isVerified || isVerifiedPro) && (
          <a
            className="verify-icon"
            href={
              accountIsLeaderSupplier
                ? '//sale.alibaba.com/p/verifiedpro'
                : '//sale.alibaba.com/p/d7v3mp6m3'
            }
            target="_blank"
            // onClick={() => {
            //   doLog('/sc.details.companyCard', 'item=isGPS');
            // }}
            rel="nofollow"
          >
            <img
              loading="lazy"
              src={
                accountIsLeaderSupplier ? resetImage(VERIFIED_PRO_ICON) : resetImage(VERIFIED_ICON)
              }
            />
          </a>
        )}
        {/* 公司供应商类型，如Custom manufacturer */}
        {companyIdentityName && (
          <span className="company-identity detail-separator">{companyIdentityName}</span>
        )}

        {/* 公司年限 */}
        {(isNormal || isVerified || isVerifiedPro) && (
          <span className="company-life detail-separator">
            {companyJoinYears} {companyJoinYears == '1' ? 'yr' : 'yrs'}
          </span>
        )}

        {/* 公司所属国家 */}
        {companyRegisterCountry && companyRegisterCountry.toLocaleLowerCase() !== 'tw' && (
          <span className="company-country detail-separator">
            <img
              loading="lazy"
              src={`https://s.alicdn.com/@u/mobile/g/common/flags/1.0.0/assets/${companyRegisterCountry.toLocaleLowerCase()}.png`}
            />
            <span className="register-country">{companyRegisterCountry} </span>
          </span>
        )}
      </div>
    </div>
  );
}

function addDNSPrefetchTags(url: string): void {
  // 提取主机名
  const hostname = new URL(url).hostname;

  // 创建 preconnect 链接
  const preconnectLink = document.createElement('link');
  preconnectLink.rel = 'preconnect';
  preconnectLink.href = `https://${hostname}`;
  preconnectLink.crossOrigin = 'anonymous'; // 如果需要跨域请求，加上这个属性

  // 创建 dns-prefetch 链接
  const dnsPrefetchLink = document.createElement('link');
  dnsPrefetchLink.rel = 'dns-prefetch';
  dnsPrefetchLink.href = `https://${hostname}`;

  // 将链接添加到 document 的 head 部分
  document.head.appendChild(preconnectLink);
  document.head.appendChild(dnsPrefetchLink);
}
